import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';

const COLLAPSED_KEY = 'sidebar.collapsed';

export default function Layout({ children }) {
  // Persisted across reloads so the user's choice sticks. Read once on
  // mount; live source of truth from then on is React state shared with
  // Sidebar so its width + the main-content margin always agree.
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSED_KEY) === 'true'; } catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem(COLLAPSED_KEY, String(collapsed)); } catch { /* noop */ }
  }, [collapsed]);

  return (
    <div className="min-h-screen bg-[#f1f1f5]">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <main
        className="bg-white min-h-screen transition-all duration-300"
        style={{ marginLeft: collapsed ? 72 : 275 }}
      >
        {children}
      </main>
    </div>
  );
}
